var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"tab_header"},_vm._l((_vm.items),function(item){return _c('a',{key:item.id,class:{'router-link-active' : _vm.categoryValue == item.id},attrs:{"href":item.id},on:{"click":function($event){$event.preventDefault();return _vm.change(item.id)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }